import React from "react";

import classNames from "classnames";

import { SportOffer, TournamentOffer } from "@gp/offer";
import { Category } from "@gp/models";

import { ChannelResourceTypeDto } from "@api-types/chat";
import {
	ChatButton,
	TournamentStatisticsButton,
} from "@features/offer/desktop/buttons";
import OfferIcon from "@components/icons/Offer";
import { FavoritesIcon } from "../FavoritesIcon";

export function TournamentHeaderName(props: {
	sport: SportOffer;
	category: Category;
	tournament: TournamentOffer;
	isAdditionalOfferVisible?: boolean;
}) {
	let iconWrapperClasses = classNames("offer__icon", {
		"u-mar--right--xtny": props.isAdditionalOfferVisible,
	});

	return (
		<div
			className="offer__head__data offer__title"
			title={`${props.category.name} - ${props.tournament.name}`}
		>
			<FavoritesIcon tournament={props.tournament} sport={props.sport} />

			<div
				className={classNames("offer__title__wrapper", {
					"offer__title--tournament": !props.sport.isOutright,
				})}
			>
				<div className="offer__name offer__name--tournament">
					<span className={iconWrapperClasses}>
						<OfferIcon
							type="tournament"
							sport={props.sport.abrv}
							category={props.category.abrv}
							tournament={props.tournament.abrv}
							wrapperClassName="offer__icon__primary u-icon u-icon--lrg"
							catOverSportClass="offer__icon__secondary u-icon u-icon--xmed"
							className="offer__icon__inner"
						/>
					</span>

					<span className="offer__name__clip">
						{props.category.name} - {props.tournament.name}
					</span>
				</div>

				{!props.isAdditionalOfferVisible ? (
					<>
						<TournamentStatisticsButton
							tournament={props.tournament}
							isAdditionalOfferVisible={
								props.isAdditionalOfferVisible
							}
						/>

						<ChatButton
							channelType={ChannelResourceTypeDto.SPORT}
							resourceId={props.sport.id}
							sportAbrv={props.sport.abrv}
							isInTournamentHeader
						/>
					</>
				) : null}
			</div>
		</div>
	);
}
